



















































































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import MonthlyStatisticsList from './Statistics/MonthlyStatisticsList.vue';
import DashboardTableComponent from '@/components/DashboardTableComponent.vue';
import DashboardDataFooter from '@/components/DashboardDataFooter.vue';

import {API, BASE_URL} from '@/services/api/api';
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment';
import {getImage, Utils} from '@/utils/Utils';
import MonthlyStatistics from '@/models/monthlystatistics';
import VueApexCharts from 'vue-apexcharts';
import canvasMerge from '@/utils/CanvasMerge';
import {getShipList} from '@/services/api/common';
Vue.use(VueApexCharts);
@Component({
  components: {
    MonthlyStatisticsList,
    DashboardTableComponent,
    DashboardDataFooter,
    VueApexCharts,
  },

  methods: {
    ...mapActions(['showSuccessToast', 'showErrorToast', 'setShipList']),
  },

  computed: {
    ...mapGetters(['userDetails']),
  },
})
export default class Dashboard extends Vue {
  inspectionList = [];
  showSuccessToast: any;
  showErrorToast: any;
  userDetails: any;
  globalShipId: number = null;
  shipId = null;
  severityShipId = null;
  findingShipId = null;
  severityMonthDuration = 12;
  severityMonthDurationForList = 12;

  findingsMonthDuration = 12;

  modifiedInspectionList = [];

  actionPlansInspections = [];

  completeInspectionData = [];

  lastRecordsFrom = moment(new Date()).subtract(12, 'months').calendar();

  tableType = '';
  tableDataMonthDuration = null;
  header = ['Month', 'Total', 'Open', 'On Hold', 'Close'];

  severityLoader = null;
  severityBasedInspections = [];
  monthlyStatisticsList: MonthlyStatistics[] = [];

  findingsLoader = false;
  findingColors = [];
  findingsChartType = 'pie';
  findingsDataExample = {
    data: [],
    chartOptions: {},
  };
  severityChartType = 'bar';
  severityListLoader = false;
  actionPlanListLoader = false;
  newInspectionsListLoader = false;
  severityColors = [];
  severityTypes = [];
  severityData = [];
  severityDataExample = {
    data: [],
    chartOptions: {},
  };
  sortedHeatMapData = [];

  severityDataFromAPI = [];
  finndingDataFromAPI = [];

  monthlyStatLoader = false;

  shipList: any[];
  globalShipImg = '';
  shipImgLoader = false;
  shipDots = [];
  howercontectText = '';
  deckDots = [];
  createdShipImage = '';

  globalShipInspectionList = [];

  isScreenLoading = true;
  setShipList: any;
  heatMapDataList: any[];
  hidePage = false;

  mounted() {
    this.getLastWorkedShip();
    this.fetchShipList();
  }

  /**
   *
   * @returns 'Last worked ship by logged in user'
   */
  async getLastWorkedShip() {
    try {
      const response = await API.fetchLastUsedShip();

      if (response.shipId) {
        this.globalShipId = response.shipId;
      } else {
        console.error(response);

        // this.showErrorToast({msg: 'Network Error'});
      }
    } catch (e) {
      console.error(e);
      this.showErrorToast({msg: 'Network Error'});
    }
  }

  /**
   * @returns fetch list of ship
   */
  async fetchShipList() {
    try {
      const response = await getShipList();

      if (response?.data.length > 0) {
        this.setShipList();
        this.shipList = response.data;

        this.isScreenLoading = false;

        this.loadInspectionData();
        this.onGlobalShipChange();
        this.getActionPlanInspections();
        this.getTableDataBasedOnSeverity();
        this.getMonthlyStatistics();
        this.getDataForHeatMap();
      } else {
        this.isScreenLoading = false;
        this.hidePage = true;
        this.showErrorToast({
          msg: 'Permissions have not been assigned to this user properly. Please assign permissions',
        });
      }
    } catch (e) {
      console.error(e);
      this.isScreenLoading = false;
      this.hidePage = true;

      this.showErrorToast({
        msg: 'Network Error',
      });
    }
  }
  /**
   * @returns get all ships and decks inspection
   */
  async getDataForHeatMap() {
    try {
      const response = await API.fetchDataForHeatMap();
      if (response.data) {
        const data = response.data;
        this.heatMapDataList = data;
      } else {
        this.showErrorToast({msg: 'Network Error'});
      }
    } catch (e) {
      this.showErrorToast({msg: 'Network Error'});
    }
  }
  /**
   * @returns default ship getter
   */
  get defaultShip() {
    return this.globalShipId;
  }

  /**
   * @returnscurrent rendered chart type of severity
   */
  get severitychartType() {
    return this.severityChartType;
  }
  /**
   * @returns current rendered chart options of severity
   */
  get severityChartOption() {
    return this.severityDataExample.chartOptions;
  }

  /**
   * @returns current rendered chart data of severity
   */
  get severityChartData() {
    return this.severityDataExample.data;
  }
  /**
   * @returns current rendered chart options of findings
   */
  get findingsChartOption() {
    return this.findingsDataExample.chartOptions;
  }
  /**
   * @returns current rendered chart dynamic height
   */
  get getHeight() {
    return this.findingsChartType !== 'radar' ? 350 : 500;
  }
  /**
   * @returns current rendered chart dynamic height of severity
   */
  get getSeverityHeight() {
    return this.severityChartType !== 'radar' ? 350 : 500;
  }
  /**
   * @returns current rendered chart data findings
   */
  get findingsChartData() {
    return this.findingsDataExample.data;
  }

  /**
   * @returns refresh inspection data for chart on default/global ship change
   */
  onGlobalShipChange() {
    this.fetchInspectionByShip();
    this.getSeverityChartData(this.globalShipId);
    this.getFindingsChartData(this.globalShipId);
  }
  /**
   * @returns get all inspection of selected ship
   */
  async fetchInspectionByShip() {
    this.shipImgLoader = true;
    try {
      let params = {
        shipid: this.globalShipId,
      };
      const response = await API.getInspectionListByShip(params);
      if (response.data?.length > 0) {
        const data = response.data;

        this.globalShipInspectionList = data;

        let ship = this.shipList.find((me) => me.shipId === this.globalShipId);
        this.globalShipImg = await getImage(ship.imagePath);

        this.createdShipImage = '';
        this.shipId = null;
      } else {
        this.shipImgLoader = false;

        let ship = this.shipList.find((me) => me.shipId === this.globalShipId);
        this.globalShipImg = await getImage(ship.imagePath);
        this.createdShipImage = '';
      }
    } catch (e) {
      this.shipImgLoader = false;

      this.showErrorToast({msg: 'Network Error'});
    }
  }

  /**
   * @returns on load ship image creating inspection dots and returns new ship image with inspection dots
   */
  shipImageLoad() {
    let _this = this;
    this.shipImgLoader = false;
    this.renderDot();
    window.onmousemove = function (e) {
      const main = e.target as HTMLImageElement;
      if (main.classList.contains('shipimg')) {
        //	Content of dot which is hovered
        const $target = main.nextElementSibling as HTMLElement;

        //	Only work with hovered target
        //	Add visible class hovered elem to distinguish
        if (!$target.classList.contains('visible')) {
          $target.classList.add('visible');
        } else {
          //	Get viewport offset of tooltip element
          let offset = $target.parentElement.getBoundingClientRect();
          //	Tooltip distance from mouse(px)
          let tipDist = 15;
          //	Calc and set new tooltip location

          offset = main.getBoundingClientRect();
          let x = e.clientX - offset.left;
          let y = e.clientY - offset.top;
          let cw = main.clientWidth;
          let ch = main.clientHeight;
          let iw = main.naturalWidth;
          let ih = main.naturalHeight;
          let posx = (x / cw) * iw;
          let posy = (y / ch) * ih;
          let left = e.clientX - offset.left + tipDist;
          if (main.clientWidth < x + 350 + tipDist) {
            left = x - 200 - tipDist;
          }

          $target.style.top = e.clientY - offset.top + tipDist + 'px';
          $target.style.left = left + 'px';
          let detactMouse = false;
          _this.shipDots.map((dots) => {
            if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * main.naturalWidth) {
              _this.howercontectText = ` <span> <span style="color: ${dots.color}">${dots.severity} </span> Severity Inspection</span>
                    <span>Inspection ID: ${dots.inspectionID}</span>
                    <span>Inspection Date: ${dots.inspectionDate}</span>
                    <span>Finding: ${dots.finding}</span>
                    <span>Inspection image:</span>
                    <span> <img src="${dots.attachments}" /> </span>`;
              // _this.howercontectText =
              //   'Click here to view inspection : ' +
              //   dots.inspectionCode +
              //   ' (ID: ' +
              //   dots.inspectionID +
              //   ')';

              main.style.cursor = 'pointer';
              detactMouse = true;
            }
          });

          if (!detactMouse) {
            const ship = _this.shipList.find((me) => {
              return me.shipId === _this.globalShipId;
            });

            const decks = ship.drawings;

            const deck = decks.find((d) => {
              d.topY <= posy && posy <= d.bottomY;
            });

            if (deck) {
              _this.howercontectText = 'Click here to view deck: ' + deck.name;
              main.style.cursor = 'unset';
            } else {
              _this.howercontectText = '';
              main.style.cursor = 'unset';
            }
          }
        }
      } else if (main.classList.contains('deckimg')) {
        //	Content of dot which is hovered
        let imageRef = _this.$refs.deckImageRef as HTMLImageElement;
        if (!imageRef) {
          return;
        }
        let offset = imageRef.getBoundingClientRect();
        let x = e.clientX - offset.left;
        let y = e.clientY - offset.top;
        let cw = main.clientWidth;
        let ch = main.clientHeight;
        let iw = main.naturalWidth;
        let ih = main.naturalHeight;
        let posx = (x / cw) * iw;
        let posy = (y / ch) * ih;

        let detactMouse = false;
        _this.deckDots.map((dots) => {
          if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.005 * main.naturalWidth) {
            _this.howercontectText =
              'Click here to view inspection : ' + dots.inspectionCode + ' (ID: ' + dots.inspectionID + ')';
            main.style.cursor = 'pointer';
            detactMouse = true;
          }
        });
        if (!detactMouse) {
          main.style.cursor = 'unset';
          _this.howercontectText = '';
        }
      } else {
        //	Remove visible class
        var content = document.getElementsByClassName('hovercontentDashboard');
        for (var i = 0; i < content.length; i++) {
          content[i].classList.remove('visible');
        }
      }
    };
  }

  /**
   * @returns navigate to inspection detail page based on clicked inspection dot
   */
  async onShipClick(e) {
    let imageRef = this.$refs.shipImageRef as HTMLImageElement;
    let offset = imageRef.getBoundingClientRect();
    let x = e.clientX - offset.left;
    let y = e.clientY - offset.top;
    let cw = imageRef.clientWidth;
    let ch = imageRef.clientHeight;
    let iw = imageRef.naturalWidth;
    let ih = imageRef.naturalHeight;
    let posx = (x / cw) * iw;
    let posy = (y / ch) * ih;

    let detactMouse = false;
    this.shipDots.map((dots) => {
      if (Utils.mouseDistance(dots.x, dots.y, posx, posy) < 0.003 * imageRef.naturalWidth) {
        this.$router.push(`/view-inspection/` + dots.inspectionID);
        detactMouse = true;
      }
    });
  }

  /**
   * @returns creating dots at ship  where inspection in created with severity color
   */
  renderDot() {
    this.shipDots = [];
    if (!this.shipImgLoader && this.globalShipImg && this.globalShipInspectionList.length > 0) {
      let imageRef = this.$refs.shipImageRef as HTMLImageElement;
      this.globalShipInspectionList.map((inspection) => {
        //

        const points = inspection.additionalInfo;
        let deckWidth = inspection.deckImageWidth;
        let deckHeight = inspection.deckImageHeight;
        let shipHeight = inspection.shipImageHeight;
        let shipWidth = inspection.shipImageWidth;
        let y = null;
        let framePosition = null;

        if (inspection.isMisc) {
          y = (points.deckTopY + points.deckBottomY) / 2;
          let totalFrame = points.frameUpto - points.frameFrom;
          let pixelsCountInZone = points.zoneEndPoint - points.zoneStartPoint;
          let pixelsInEachframes = pixelsCountInZone / totalFrame;
          let thisframePosition = points.frameUpto - inspection.frameNumber;
          framePosition = points.zoneStartPoint + thisframePosition * pixelsInEachframes;
        } else {
          y = (points.deckTopY + points.deckBottomY) / 2;
          framePosition = points.location_X;
        }

        let widthPoint = (shipWidth / deckWidth) * framePosition;
        let heightPoint = y;

        this.shipDots.push({
          x: widthPoint,
          y: heightPoint,
          radius: 0.003 * imageRef.naturalWidth,
          color: Utils.getBackgroundColor(inspection.severity),
          severity: inspection.severity,
          inspectionID: inspection.inspectionID,
          inspectionCode: inspection.inspectionCode,
          finding: inspection.finding,
          inspectionDate: Utils.formatDate(inspection.inspectionDate),
          attachments:
            inspection.attachments &&
            inspection.attachments[0] &&
            inspection.attachments[0].filePath + inspection.attachments[0].fileName,
        });
      });
      this.mergeImage();
    }
  }
  /**
   * @returns merge ship image and inspection dots returns new image as canvas base64
   */
  mergeImage() {
    let img;
    let dots;

    img = this.globalShipImg;
    dots = this.shipDots;

    canvasMerge(img, dots, {
      crossOrigin: 'anonymous',
      drawType: 'circle',
    }).then((b64) => {
      this.createdShipImage = b64;
    });
  }

  /**
   *@param shipId global ship or selected ship at severity graph
   * @returns refetch data based on ship id and render severity chart
   */
  async getSeverityChartData(shipId) {
    this.severityLoader = true;

    try {
      let params = {
        nmonths: this.severityMonthDuration,
        shipid: shipId,
      };
      let response = await API.fetchSeverityChartData(params);

      if (response.data) {
        let data = response.data;

        this.severityLoader = false;
        this.severityDataFromAPI = data;
        this.severityDataExample = {
          data: [],
          chartOptions: {},
        };
        this.getchartOptionsSeverity(this.severityChartType, 'severity');
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (e) {
      console.error(e);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.monthlyStatLoader = false;
    }
  }

  /**
   *@param shipid global ship or selected ship at findings graph
   * @param nmonths selected month duration
   * @returns refetch data based on ship id and render findings chart
   */
  async getFindingsChartData(shipId) {
    this.findingsLoader = true;

    try {
      let params = {
        nmonths: this.findingsMonthDuration,
        shipid: shipId,
      };
      let response = await API.fetchFindingsChartData(params);

      if (response.data) {
        let data = response.data;
        this.finndingDataFromAPI = data;
        this.findingsLoader = false;
        this.findingsDataExample = {
          data: [],
          chartOptions: {},
        };
        this.getchartOptionsFindings(this.findingsChartType, 'findings');
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (e) {
      console.error(e);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.monthlyStatLoader = false;
    }
  }

  /**
   * @returns fetch monthly statistics of total inspections created
   */
  async getMonthlyStatistics() {
    this.monthlyStatLoader = true;
    try {
      let response = await API.fetchMonthlyStatistics();

      if (response.data) {
        let data: MonthlyStatistics[] = response.data;

        this.monthlyStatisticsList = data;
      } else {
        this.showErrorToast({msg: response.message});
      }
    } catch (e) {
      console.error(e);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.monthlyStatLoader = false;
    }
  }

  /**
   * @param shipid selected ship in inspection (must see) table
   * @param nmonths selected month duration
   * @param severityname severity type
   * @returns  must see inspection list
   */
  async getTableDataBasedOnSeverity() {
    this.severityListLoader = true;
    try {
      const param = {
        shipid: this.shipId,
        nmonths: this.severityMonthDurationForList,
        severityname: 'Must See',
      };
      const response = await API.fetchSeverityListData(param);
      if (response.data) {
        const data = response.data;
        this.completeInspectionData = data;
        const modifiedData = data.map((me) => {
          return {
            inspectionCode: me.code,
            inspectionId: me.inspectionId,
            totalInspections: me.number,
            shipName: me.shipName,
            deckName: me.drawingName,
            inspectionDate: me.created,
          };
        });

        this.severityBasedInspections = modifiedData;
      } else {
        console.error('error');
        this.showErrorToast({msg: 'Network error'});
      }
      //
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.severityListLoader = false;
    }
  }

  /**
   * @param ShipId selected ship in inspection action plan inspection table
   * @param FromDate last 1 year from current date
   * @param IsActionPlan inspection type
   * @returns inspection list based upon action plan
   */
  async getActionPlanInspections() {
    this.actionPlanListLoader = true;
    try {
      const param = {
        FromDate: moment(this.lastRecordsFrom, 'MM/DD/YYYY').format('YYYY-MM-DD'),
        IsActionPlan: true,
        ShipId: this.shipId,
      };
      const response = await API.getInspectionList(param);
      if (response.data) {
        const data = response.data;

        const modifiedData = data.map((me) => {
          return {
            inspectionCode: me.inspectionCode,
            inspectionId: me.inspectionID,
            totalInspections: me.totalInspections,
            shipName: me.shipName,
            deckName: me.deckName,
            inspectionDate: me.inspectionDate,
          };
        });

        this.actionPlansInspections = modifiedData;
      } else {
        this.actionPlansInspections = [];
        // this.showErrorToast({msg: 'No inspection found.'});
      }
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.actionPlanListLoader = false;
    }
  }

  /**
   * @param ShipId selected ship in  new inspections table
   * @param FromDate last date from current date based on selected months
   * @returns  new inspection list based
   */
  async loadInspectionData() {
    this.newInspectionsListLoader = true;

    try {
      this.inspectionList = [];
      const param = {
        ShipId: this.shipId,
        FromDate: moment(this.lastRecordsFrom, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      };
      const response = await API.getInspectionList(param);
      if (response.data) {
        const data = response.data;
        this.completeInspectionData = data;
        const modifiedData = data.map((me) => {
          return {
            inspectionCode: me.inspectionCode,
            inspectionId: me.inspectionID,
            totalInspections: me.totalInspections,
            shipName: me.shipName,
            deckName: me.deckName,
            inspectionDate: me.inspectionDate,
          };
        });

        this.modifiedInspectionList = modifiedData;
      } else if (response.errors) {
        if (response.errors.ShipId) {
          this.showErrorToast({msg: response.errors.ShipId[0]});
        } else if (response.errors.InspectionId) {
          this.showErrorToast({msg: response.errors.InspectionId[0]});
        } else if (response.errors.FromDate) {
          this.showErrorToast({msg: response.errors.FromDate[0]});
        } else if (response.errors.ToDate) {
          this.showErrorToast({msg: response.errors.ToDate[0]});
        }
      } else {
        this.modifiedInspectionList = [];
      }
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network error'});
    } finally {
      this.newInspectionsListLoader = false;
    }
  }

  /**
   * @param params selected shipid of child table
   * @param type child table type
   * @returns dynamic inspection function
   */
  onShipChange(params, type) {
    if (type === 'actionplan') {
      this.shipId = params;
      this.getActionPlanInspections();
    }
    if (type === 'newinspection') {
      this.shipId = params;
      this.loadInspectionData();
    }

    if (type === 'mustsee') {
      this.shipId = params;
      this.getTableDataBasedOnSeverity();
    }
  }

  /**
   * @param param chart type
   * @param type inspection type
   * @returns render chart function
   */
  onChartChange(param, type) {
    if (type === 'findings') {
      this.getchartOptionsFindings(param.toLowerCase(), type);
    } else if (type === 'severity') {
      this.getchartOptionsSeverity(param.toLowerCase(), type);
    }
  }

  /**
   * @param params child params (shipId, lastRecordFrom)
   * @param type inspection type
   * @returns chart function
   */
  onDisplayClick(params, type) {
    this.shipId = params.shipId;
    if (type === 'findings') {
      this.findingsMonthDuration = params.lastMonths;
      this.getFindingsChartData(params.shipId);
    } else {
      this.findingsMonthDuration = params.lastMonths;
      this.getSeverityChartData(params.shipId);
    }
  }

  /**
   * @param chartType chart type
   * @param dataFor inspection type
   * @returns render chart
   */
  getchartOptionsSeverity(chartType, dataFor) {
    if (this.severityDataFromAPI.length == 0) {
      return;
    }
    switch (chartType) {
      case 'pie':
        this[`${dataFor}ChartType`] = chartType;
        this.severityDataExample.data = [];
        this.severityDataFromAPI.map((data: any) => {
          this.severityDataExample.data.push(data.countName);
        });
        this.severityDataExample.chartOptions = {
          chart: {
            width: 380,
            type: 'pie',
          },
          labels: this.severityDataFromAPI.map((d: any) => d.severityName),
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
            theme: 'dark',
          },
          colors: this.severityDataFromAPI.map((d: any) => d.color),
          legend: {
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: this.severityDataFromAPI.map((d) => d.color),
              useSeriesColors: false,
            },
          },
        };
        break;

      case 'bar':
        this[`${dataFor}ChartType`] = chartType;
        this.severityDataExample.data = [
          {
            name: 'Severity',
            data: this.severityDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.severityDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
          },
          colors: this.severityDataFromAPI.map((d: any) => d.color),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: this.modifyNameForChart(this.severityDataFromAPI),
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: this.severityDataFromAPI.map((d) => d.color),
                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },
        };
        break;
      case 'column':
        this[`${dataFor}ChartType`] = 'bar';
        this.severityDataExample.data = [
          {
            name: 'Severity',
            data: this.severityDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.severityDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
          },
          colors: this.severityDataFromAPI.map((d: any) => d.color),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: this.modifyNameForChart(this.severityDataFromAPI),

            labels: {
              style: {
                colors: this.severityDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },
        };

        break;

      case 'line':
        this[`${dataFor}ChartType`] = chartType;
        this.severityDataExample.data = [
          {
            name: 'Severity',
            data: this.severityDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.severityDataExample.chartOptions = {
          chart: {
            type: 'line',
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            row: {
              colors: ['transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            categories: this.modifyNameForChart(this.severityDataFromAPI),

            labels: {
              style: {
                colors: this.severityDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },

          scales: {
            y: {
              ticks: {
                stepSize: 1,
              },
            },
          },
          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
            float: false,
            min: 0,
            max: this.getMaxValue(this.severityDataFromAPI),
            tickAmount: this.getMaxValue(this.severityDataFromAPI),
          },
        };
        break;

      case 'radar':
        this[`${dataFor}ChartType`] = chartType;
        this.severityDataExample.data = [
          {
            name: 'Severity',
            data: this.severityDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.severityDataExample.chartOptions = {
          chart: {
            height: 500,
            type: 'radar',
            toolbar: {
              show: false,
            },
          },

          dataLabels: {
            enabled: true,
          },
          tooltip: {
            enabled: true,

            style: {
              fontSize: '12px',
            },
            onDatasetHover: {
              highlightDataSeries: false,
            },
            x: {
              show: true,
              formatter: function (val) {
                return val;
              },
            },
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },

          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
            },
          },

          legend: {
            show: false,
          },
          xaxis: {
            categories: this.modifyNameForChart(this.severityDataFromAPI),

            labels: {
              style: {
                colors: this.severityDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },
        };
        break;

      case 'donut':
        this[`${dataFor}ChartType`] = chartType;
        this.severityDataExample.data = [];
        this.severityDataFromAPI.map((data: any) => {
          this.severityDataExample.data.push(data.countName);
        });
        this.severityDataExample.chartOptions = {
          chart: {
            width: 380,
            type: 'donut',
          },
          tooltip: {
            enabled: true,
            theme: true,
          },
          labels: this.severityDataFromAPI.map((d: any) => d.severityName),
          dataLabels: {
            enabled: false,
          },
          colors: this.severityDataFromAPI.map((d: any) => d.color),
          legend: {
            position: 'bottom',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: this.severityDataFromAPI.map((d) => d.color),
            },
          },
        };

        break;

      case 'area':
        this[`${dataFor}ChartType`] = chartType;
        this.severityDataExample.data = [
          {
            name: 'Severity',
            data: this.severityDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.severityDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
          },
          labels: this.severityDataFromAPI.map((d: any) => d.severityName),
          colors: this.severityDataFromAPI.map((d: any) => d.color),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          stroke: {
            curve: 'straight',
          },
          xaxis: {
            categories: this.modifyNameForChart(this.severityDataFromAPI),

            labels: {
              style: {
                colors: this.severityDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
            floating: false,
            min: 0,
            max: this.getMaxValue(this.severityDataFromAPI),
            tickAmount: this.getMaxValue(this.severityDataFromAPI),
          },
        };
        break;

      case 'heatmap':
        this[`${dataFor}ChartType`] = chartType;

        this.severityDataExample.data = this.mapHeatmapData();

        this.severityDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'heatmap',
          },
          dataLabels: {
            enabled: true,
            formatter: (value, chartobj) => {
              let obj = this.sortedHeatMapData[chartobj.seriesIndex];
              let data = obj.data[chartobj.dataPointIndex];
              return data?.deck?.totalInspectionCount;
            },
          },

          tooltip: {
            enabled: true,
            y: {
              formatter: (value, chartobj) => {
                let obj = this.sortedHeatMapData[chartobj.seriesIndex];
                let data = obj.data[chartobj.dataPointIndex];
                return data?.deck?.totalInspectionCount;
              },
            },
          },

          xaxis: {
            labels: {
              style: {
                colors: this.severityDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: this.severityDataFromAPI.map((d) => d.color),
                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },

          legend: {
            position: 'bottom',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: this.severityDataFromAPI.map((d) => d.color),
              useSeriesColors: false,
            },
          },

          plotOptions: {
            heatmap: {
              colorScale: {
                ranges: [
                  {
                    from: 0,

                    to: 1,
                    color: '#08d1fc',
                    name: 'Low',
                  },
                  {
                    from: 1.1,
                    to: 2,
                    color: '#fe9b0a',
                    name: 'Medium',
                  },
                  {
                    from: 2.1,
                    to: 3,
                    color: '#e23838',
                    name: 'High',
                  },
                  {
                    from: 3.1,
                    to: 4,
                    color: '#fb0ad7',
                    name: 'Must See',
                  },
                ],
              },
            },
          },
        };
        break;
    }
  }

  /**
   * @param heatMapDataList all ship and deck inspections
   * @returns render heatmap chart for severity
   */
  mapHeatmapData() {
    let data = [];

    this.heatMapDataList.forEach((ship, shipindex) => {
      data.push({
        name: ship.shipName,
        data: [],
      });
      if (ship.deckData.length > 0) {
        ship.deckData.forEach((deck, index) => {
          data[shipindex].data.push({
            x: `Deck ${index + 1}`.split(' '),
            y: deck.severityRange,
            deck: deck,
          });
        });
      }
    });

    this.sortedHeatMapData = data.sort((a, b) => (a.data.length < b.data.length ? 1 : -1));
    return this.sortedHeatMapData;
  }

  /**
   * @param chartType chart type
   * @param dataFor inspection type
   * @returns render chart of findings
   */
  getchartOptionsFindings(chartType, dataFor) {
    switch (chartType) {
      case 'pie':
        this.findingsChartType = chartType;
        this.findingsDataExample.data = [];
        this.finndingDataFromAPI.map((data: any) => {
          this.findingsDataExample.data.push(data.countName);
        });
        this.findingsDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'pie',
          },
          labels: this.finndingDataFromAPI.map((d: any) => d.finding_Name || '-'),
          dataLabels: {
            enabled: false,
          },
          tooltip: {
            enabled: true,
            theme: true,
          },
          colors: this.finndingDataFromAPI.map((d: any) => d.color),
          legend: {
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: this.finndingDataFromAPI.map((d) => d.color),
              useSeriesColors: false,
            },
          },
        };
        break;

      case 'bar':
        this.findingsChartType = chartType;
        this.findingsDataExample.data = [
          {
            name: 'Findings',
            data: this.finndingDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.findingsDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
            toolbar: {
              show: false,
            },
          },
          colors: this.finndingDataFromAPI.map((d: any) => d.color),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: this.modifyNameForChart(this.finndingDataFromAPI),
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: this.finndingDataFromAPI.map((d) => d.color),
                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },
        };
        break;
      case 'column':
        this.findingsChartType = 'bar';
        this.findingsDataExample.data = [
          {
            name: 'Findings',
            data: this.finndingDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.findingsDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
          },
          colors: this.finndingDataFromAPI.map((d: any) => d.color),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          xaxis: {
            categories: this.modifyNameForChart(this.finndingDataFromAPI),
            labels: {
              style: {
                colors: this.finndingDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
          },
        };

        break;

      case 'line':
        this.findingsChartType = chartType;
        this.findingsDataExample.data = [
          {
            name: 'Findings',
            data: this.finndingDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.findingsDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'straight',
          },
          grid: {
            row: {
              colors: ['transparent'], // takes an array which will be repeated on columns
              opacity: 0.5,
            },
          },
          xaxis: {
            categories: this.modifyNameForChart(this.finndingDataFromAPI),
            type: 'category',

            labels: {
              style: {
                colors: this.finndingDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
                trim: false,
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
            },
            floating: false,
            min: 0,
            max: this.getMaxValue(this.finndingDataFromAPI),
            tickAmount: this.getMaxValue(this.finndingDataFromAPI),

            formatter: (value) => {
              return value.toFixed(0);
            },
          },
        };
        break;

      case 'radar':
        this.findingsChartType = chartType;
        this.findingsDataExample.data = [
          {
            name: 'Findings',
            data: this.finndingDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.findingsDataExample.chartOptions = {
          chart: {
            id: 'findingsRadar',
            height: 500,
            type: 'radar',
            toolbar: {
              show: false,
            },
          },

          dataLabels: {
            enabled: true,
          },
          tooltip: {
            enabled: true,

            style: {
              fontSize: '12px',
            },
            onDatasetHover: {
              highlightDataSeries: false,
            },
            x: {
              show: true,

              formatter: function (val) {
                return val;
              },
            },
            y: {
              formatter: function (val) {
                return val;
              },
            },
          },

          plotOptions: {
            radar: {},
          },

          legend: {
            show: false,
          },

          xaxis: {
            categories: this.modifyNameForChart(this.finndingDataFromAPI),

            labels: {
              style: {
                colors: this.finndingDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },
        };
        break;

      case 'donut':
        this.findingsChartType = chartType;
        this.findingsDataExample.data = [];
        this.finndingDataFromAPI.map((data: any) => {
          this.findingsDataExample.data.push(data.countName);
        });
        this.findingsDataExample.chartOptions = {
          chart: {
            width: 380,
            type: 'donut',
          },
          tooltip: {
            enabled: true,
            theme: true,
          },
          labels: this.finndingDataFromAPI.map((d: any) => d.finding_Name),
          dataLabels: {
            enabled: false,
          },
          colors: this.finndingDataFromAPI.map((d: any) => d.color),
          legend: {
            position: 'bottom',
            fontSize: '12px',
            fontFamily: 'Helvetica, Arial',
            fontWeight: 400,
            labels: {
              colors: this.severityDataFromAPI.map((d) => d.color),
            },
          },
        };

        break;

      case 'area':
        this.findingsChartType = chartType;
        this.findingsDataExample.data = [
          {
            name: 'Findings',
            data: this.finndingDataFromAPI.map((d: any) => d.countName),
          },
        ];
        this.findingsDataExample.chartOptions = {
          chart: {
            height: 350,
            type: 'bar',
          },
          labels: this.finndingDataFromAPI.map((d: any) => d.finding_Name),
          colors: this.finndingDataFromAPI.map((d: any) => d.color),
          plotOptions: {
            bar: {
              columnWidth: '45%',
              distributed: true,
              horizontal: true,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            show: false,
          },
          stroke: {
            curve: 'straight',
          },
          xaxis: {
            categories: this.modifyNameForChart(this.finndingDataFromAPI),

            labels: {
              style: {
                colors: this.finndingDataFromAPI.map((d: any) => d.color),
                fontSize: '12px',
              },
            },
          },

          yaxis: {
            labels: {
              style: {
                colors: ['#ffffff'],

                fontSize: '12px',
              },

              trim: false,
              minHeight: 150,
            },
            min: 0,
            max: this.getMaxValue(this.finndingDataFromAPI),
            tickAmount: this.getMaxValue(this.finndingDataFromAPI),
            formatter: (value) => {
              return value.toFixed(0);
            },
          },
        };
        break;
    }
  }
  /**
   * @param childParam selected month duration of child
   * @param type child/module type
   * @returns fetch inspection function
   */
  onMonthDurationChange(childParam, type) {
    switch (type) {
      case 'severity':
        this.severityMonthDuration = childParam.months;
        break;

      case 'findings':
        this.findingsMonthDuration = childParam.months;
        break;

      case 'actionplan':
        this.lastRecordsFrom = moment(new Date()).subtract(childParam.months, 'months').calendar();
        this.shipId = childParam.shipId;

        this.getActionPlanInspections();
        break;

      case 'newinspection':
        this.lastRecordsFrom = moment(new Date()).subtract(childParam.months, 'months').calendar();
        this.shipId = childParam.shipId;
        this.loadInspectionData();
        break;

      case 'mustsee':
        this.lastRecordsFrom = moment(new Date()).subtract(childParam.months, 'months').calendar();
        this.shipId = childParam.shipId;
        this.getTableDataBasedOnSeverity();
        break;
    }
  }

  /**
   * @param data inspection list of severity,findings chart
   * @returns category name of chart in array
   */
  modifyNameForChart = (data) => {
    let stringAsArray = [];

    data.forEach((element) => {
      if (element?.finding_Name) {
        stringAsArray.push(element?.finding_Name.split(' '));
      } else stringAsArray.push(element?.severityName.split(' '));
    });
    return stringAsArray;
  };

  /**
   * @param data inspection list of severity,findings chart
   * @returns maximum count of particular type inspection
   */
  getMaxValue = (data) => {
    let counts = data.map((me) => me.countName);
    return Math.max(...counts);
  };
}
